export default {
    root: {
        class: [
            // Shape
            'rounded-md',

            // Position
            'absolute left-0 top-0 mt-2',
            'z-40 transform origin-center',

            // Color
            'bg-gray-50',
            'text-black',
            'shadow-06',
        ],
    },
    content: {
        class: ['items-center flex', 'rounded-md', 'border border-gray-300'],
    },
    transition: {
        enterFromClass: 'opacity-0 scale-y-[0.8]',
        enterActiveClass: 'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
        leaveActiveClass: 'transition-opacity duration-100 ease-linear',
        leaveToClass: 'opacity-0',
    },
};
